module.exports = __webpack_public_path__ + "adad13b8de1d66597982808cac2b26ca.fbx";